<template>
    <div class="page-waiting">
        请前往授权页面授权登录或者<a href="http://www.renrendonghua.com">返回首页</a>
    </div>
</template>

<script type="text/ecmascript-6">

    import axios from 'axios';
    import vue from 'vue';
    vue.prototype.$axios = axios;
    import qs from 'qs';
    vue.prototype.qs = qs;
    import VueCookies from 'vue-cookies'
    vue.use(VueCookies);
    import updateTdk from "@/utils/tdk";
    export default {

        components: {
        },
        tdk() {
            return {
                title: this.headTitle,
                description: this.headDesc,
                keywords: this.headKeywords,
                ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
            };
        },
        data () {
            return{
                headTitle: "人人动画网【官网】",
                headKeywords: "keywords---人人动画网【官网】",
                headDesc: "description---人人动画网【官网】",
                isMounted: false //for control not ssr render
            }
        },
        serverPrefetch() {
            this.setSeo();
            updateTdk.call(this);
        },
        mounted() {
            this.isMounted = true;
            this.timer = setInterval(this.checkLogin, 1000);
        },
        methods:{
            setSeo() {
                this.headTitle = "QQ登录-人人动画网【官网】";
                this.headKeywords = "人人动画网,动画短视频,短视频";
                this.headDesc ="人人动画网，是一个动画短视频分享社区，凭借丰富的快速动画创意资源，和行业深厚的动画技术背景，助力每个人实现自己的动画梦。";
            },
            checkLogin(){
                let _this=this;
                let checkurl='/api/checkLogin?time='+ new Date().getMilliseconds();
                _this.$axios.get(checkurl).then(function(result2){
                    if(result2.data.isLogin&&result2.data.casFastUserModel!=null){
                        if(_this.$cookies.get("formUrl")!=null&&_this.$cookies.get("formUrl")!=undefined&&_this.$cookies.get("formUrl")!=""){
                            window.location.href =_this.$cookies.get("formUrl")
                        }else{
                            window.location.href ="http://www.renrendonghua.com";
                        }

                    }
                })
            }

        }
    }

</script>


<style scoped lang="less">
    .page-waiting{
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: @NAVHEIGHT;
        height: 50vh;
    }
</style>